import { render } from "./login-phone.vue?vue&type=template&id=0eedfddd"
import script from "./login-phone.vue?vue&type=script&lang=js"
export * from "./login-phone.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\csxlib-digital-resource\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__